import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import NumberField from "src/components/Form/NumberFormatFieldV2/NumberFormatFieldV2";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import TypeaheadField from "src/components/Form/TypeaheadFieldV2/TypeaheadFieldV2";
import Icon, { IconName } from "src/components/Icon/Icon";
import * as S from "src/constants/StringConstants";

const IndividualInforceForm = ({ productDetails }) => {
  const [forms, setForms] = useState([{ id: 0 }]);

  useEffect(() => {
    const dtoList = productDetails?.inforcePolicies;

    if (dtoList?.length > 0) {
      const initialForms = dtoList.map((_, idx) => ({ id: idx }));
      setForms(initialForms);
    }
  }, [productDetails?.inforcePolicies]);

  const addNewPolicy = () => {
    setForms([...forms, { id: Date.now() }]);
  };

  const removePolicy = id => {
    setForms(prev => prev.filter(form => form.id !== id));
  };

  return (
    <Col sm="4">
      {forms.map((form, index) => (
        <div key={form.id}>
          <Col style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between" }}>
            <div className="app-form-header">
              <h4 className="form-title">{S.APP_PRODUCT_INDIVIDUAL_INFORCE_TITLE}</h4>
            </div>
            {index !== 0 && (
              <Col
                sm="5"
                className="d-flex align-items-center"
                style={{ textAlign: "right", gap: "4px", cursor: "pointer" }}
                onClick={() => removePolicy(form.id)}>
                <span className="product-detail__remove-policy">{S.APP_PRODUCT_REMOVE_POLICY_LABEL}</span>
                <Icon name={IconName.RemoveMinusCircleBlue} size="20px" />
              </Col>
            )}
          </Col>

          <Row>
            <Col sm="5">
              <TypeaheadField
                name={`inforcePolicies[${index}].carrierTypeID`}
                label={S.APP_FIELD_CARRIER_LABEL}
                options={productDetails?.selectCarrierTypeList}
              />
            </Col>
            <Col sm="5">
              <TypeaheadField
                name={`inforcePolicies[${index}].productTypeID`}
                label={S.APP_FIELD_PRODUCT_LABEL}
                options={productDetails?.selectProductTypeList}
              />
            </Col>
          </Row>

          <Row>
            <Col sm="5">
              <NumberField
                name={`inforcePolicies[${index}].benefit`}
                label={S.APP_PRODUCT_FIELD_BENEFIT}
                prefix="$"
                thousandSeparator={true}
                decimalScale={2}
              />
            </Col>
            <Col sm="5">
              <TextField
                name={`inforcePolicies[${index}].eliminationPeriod`}
                label={S.APP_PRODUCT_FIELD_ELIMINATION_PERIOD}
              />
            </Col>
          </Row>

          <Row>
            <Col sm="5">
              <TextField name={`inforcePolicies[${index}].benefitPeriod`} label={S.APP_PRODUCT_FIELD_BENEFIT_PERIOD} />
            </Col>
            <Col sm="5">
              <TypeaheadField
                name={`inforcePolicies[${index}].paidByTypeID`}
                label={S.APP_PRODUCT_FIELD_PAID_BY}
                options={productDetails?.selectPaidByTypeList}
              />
            </Col>
          </Row>
        </div>
      ))}

      <Row>
        <Col
          sm="10"
          className="d-flex justify-content-end align-items-center"
          style={{ gap: "4px", cursor: "pointer", margin: "25px 0px 25px 0px" }}
          onClick={addNewPolicy}>
          <span className="product-detail__add-policy">{S.APP_PRODUCT_ADD_POLICY_LABEL}</span>
          <Icon name={IconName.AddPlusCircleBlue} size="20px" />
        </Col>
      </Row>

      <Row>
        <Col sm="8" className="app-form-header">
          <h4 className="form-title">{S.APP_PRODUCT_EXISTING_GROUP_LTD_INFORCE_TITLE}</h4>
        </Col>
      </Row>

      <Row>
        <Col sm="5">
          <TextField name="groupLTDPercent" label={S.APP_PRODUCT_FIELD_GROUP} />
        </Col>
        <Col sm="5">
          <TypeaheadField
            name="ltdPaidById"
            label={S.APP_PRODUCT_FIELD_PAID_BY}
            options={productDetails?.selectPaidByTypeList}
          />
        </Col>
      </Row>

      <Row>
        <Col sm="5">
          <TextField name="groupLTDCap" label={S.APP_PRODUCT_FIELD_GROUP_CAP} />
        </Col>
      </Row>
    </Col>
  );
};

export default IndividualInforceForm;
